import { createReducer } from "@reduxjs/toolkit";
import initialState from "./initialState";
// import moment from "moment";
import _ from "lodash";
import * as types from "../types/actions";

const setLoadingTrue = (state) => ({
  ...state,
  loading: true,
});

const findRentalFromRANumber = (rentals, raNumber) =>
  rentals.find((item) => item.rental_agreement_number === raNumber);

const filterEmptyPhotoBatch = (rentalPhotos) =>
  rentalPhotos.filter((batch) => batch.photo_urls.length > 0);

const sortImagesByTimestampDescending = (rentalPhotos) =>
  rentalPhotos.sort((prev, next) => parseInt(next.batch_date) - parseInt(prev.batch_date));

const updateOrRefreshPhoto = (state, action) => {
  const currentRA = state.currentRental;
  const response = action.response.data.Rental;
  let responseRental = findRentalFromRANumber(response, currentRA);
  let { rental_photos } = responseRental;
  rental_photos = filterEmptyPhotoBatch(rental_photos);
  rental_photos = sortImagesByTimestampDescending(rental_photos);
  responseRental = {
    ...responseRental,
    rental_photos,
  };

  const { rentals } = state;
  const rentalObject = findRentalFromRANumber(rentals, currentRA);
  const newRentalObject = {
    ...rentalObject,
    ...responseRental,
  };

  const newRentals = rentals.filter((item) => item.rental_agreement_number !== currentRA);
  newRentals.push(newRentalObject);

  return {
    ...state,
    rentals: newRentals,
    loading: false,
  };
};

const updateRefreshPhotoFailure = (state, action) => {
  return {
    ...state,
    loading: false,
    toast: {
      type: "error",
      message:
        "An error occured while updating the photo batches: " +
        (action.error.error ? action.error.error : action.error),
    },
  };
};

const appReducer = createReducer(initialState.app, {
  SAVESTATE: (state, action) => ({
    ...state,
    ...action.newstate,
  }),
  [types.LOGIN]: (state, action) => ({
    ...state,
    loginRental: action.payload.values.raNumber,
    currentRental: action.payload.values.raNumber,
  }),
  [types.LOGIN_FAILURE]: (state, action) => ({
    ...state,
    toast: {
      type: "error",
      message: "Login Failed: " + (action.error.error ? action.error.error : action.error),
    },
  }),
  [types.LOGOUT]: (state) => ({ ...initialState.app, currentRental: state.currentRental }),
  [types.GETRENTALS]: setLoadingTrue,
  [types.GETRENTALS_SUCCESS]: (state, action) => {
    const rentals = _.orderBy(
      action.response.data.Rental,
      ["pickup.dateTime", "rental_agreement_number"],
      ["desc", "desc"]
    ).reduce((accumulator, rental) => {
      let { rental_photos } = rental;
      const { virs } = rental;
      let sortedVirs = [];
      if (virs !== null) {
        sortedVirs = virs
          .map((e) => {
            const incidentDetails = !Boolean(e.incidentDetails)
              ? null
              : {
                  ...e.incidentDetails,
                  date: new Date(e.incidentDetails.date),
                };
            return {
              ...e,
              incidentDetails,
              date: new Date(e.date),
            };
          })
          .sort((a, b) => b.date - a.date);
      }
      rental_photos = filterEmptyPhotoBatch(rental.rental_photos);
      rental_photos = sortImagesByTimestampDescending(rental_photos);
      return accumulator.concat({
        ...rental,
        rental_photos,
        virs: sortedVirs,
      });
    }, []);

    return {
      ...state,
      loading: false,
      rentals,
    };
  },
  [types.GETRENTALS_FAILURE]: (state, error) => ({
    ...state,
    loading: false,
    error: error,
    rentals: [],
  }),
  [types.DELETE_TOAST]: (state) => ({
    ...state,
    toast: { type: "", message: "" },
  }),
  [types.CREATE_TOAST]: (state, action) => ({
    ...state,
    toast: {
      type: action.payload.type,
      message: action.payload.message,
    },
  }),
  [types.OPEN_POPPER]: (state) => ({
    ...state,
    popper: true,
  }),
  [types.CLOSE_POPPER]: (state) => ({
    ...state,
    popper: false,
  }),
  [types.UPDATERESERVATION]: (state) => ({
    ...state,
    worker: {
      ...state.worker,
      updateReservation: "started",
    },
  }),
  [types.UPDATERESERVATION_SUCCESS]: (state, action) => ({
    ...state,
    worker: {
      ...state.worker,
      updateReservation: _.get(action, "response.data.WebUpdateReservation.Success", false)
        ? "Success"
        : "Error",
    },
  }),
  [types.RESESTIMATE]: (state) => ({
    ...state,
    loading: true,
    worker: {
      ...state.worker,
      checkin: "busy",
    },
  }),
  [types.RESESTIMATE_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    worker: {
      ...state.worker,
      checkin: "ready",
    },
  }),
  [types.RESOPTIONS_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    worker: {
      ...state.worker,
      checkin: "ready",
    },
  }),
  [types.RESESTIMATE_FAILURE]: (state, error) => ({
    ...state,
    loading: false,
    error: error,
  }),
  [types.GETDETAILS_SUCCESS]: (state) => ({
    ...state,
    worker: {
      ...state.worker,
      checkin: "ready",
    },
  }),
  [types.UPDATE_PHOTOS]: setLoadingTrue,
  [types.UPDATE_PHOTOS_SUCCESS]: updateOrRefreshPhoto,
  [types.UPDATE_PHOTOS_FAILURE]: updateRefreshPhotoFailure,
  [types.REFRESH_PHOTOS]: setLoadingTrue,
  [types.REFRESH_PHOTOS_SUCCESS]: updateOrRefreshPhoto,
  [types.REFRESH_PHOTOS_FAILURE]: updateRefreshPhotoFailure,
});

export default appReducer;
